/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LiqPrefLedgerItem = {
  readonly id?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
  readonly last_audit_event_id?: string | null;
  effective_date?: string | null;
  name?: string | null;
  dividend_rate?: string | null;
  liquidation_preference?: string | null;
  has_dividends?: boolean | null;
  has_compounding?: boolean | null;
  compounding_period?: number | null;
  multiple_of?: LiqPrefLedgerItem.multiple_of;
  dividend_yearfrac_basis?: LiqPrefLedgerItem.dividend_yearfrac_basis;
  ledger_config: number;
};
export namespace LiqPrefLedgerItem {
  export enum multiple_of {
    '_0' = 0,
    '_1' = 1,
  }
  export enum dividend_yearfrac_basis {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
  }
}

